import { render, staticRenderFns } from "./image-lightbox.vue?vue&type=template&id=11ef21f2&scoped=true"
import script from "./image-lightbox.vue?vue&type=script&lang=js"
export * from "./image-lightbox.vue?vue&type=script&lang=js"
import style0 from "./image-lightbox.vue?vue&type=style&index=0&id=11ef21f2&prod&lang=css"
import style1 from "./image-lightbox.vue?vue&type=style&index=1&id=11ef21f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ef21f2",
  null
  
)

export default component.exports